<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            产品销售统计
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="search">
                        <template slot="daterange">
                            <Daterange :startTime="searchForm.startTime" :endTime="searchForm.endTime" @dataChange='dataChange'></Daterange>
                        </template>
                    </Search>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="goodsName" label="产品名称"></el-table-column>
                        <el-table-column prop="goodsImg" label="商品图标">
                            <template slot-scope="scope">
                            <el-popover placement="right" title="" trigger="click">
                                <img :src="imgUrl+scope.row.goodsImg" style="width: 500px"/>
                                <img slot="reference" :src="imgUrl+scope.row.goodsImg" style="width:50px">
                            </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="businessGoodsCode" label="产品销售总量"></el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {timeStr,getMonthDay,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getStaffDTO} from "@/utils/auth";
    import Search from "@/components/Search";
    import Daterange from "@/components/Daterange";
    export default{
        data(){
            return{
                tableLoading:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                imgUrl:this.$imgUrl,
                searchForm:{
                    businessCode:getStaffDTO().businessCode,
                    startTime:'',
                    endTime:'',
                }
            }
        },
        components:{
            Daterange,Search
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                this.searchData=[
                    {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
                ]
                this.searchForm.endTime = getMonthDay('e', 0)
                this.searchForm.startTime = getMonthDay('s', 0)
            },
        
            noAccountingRecord(){
                this.showModalStayInfo=true
                this.$refs.myStayInfo.init();
            },
            //日期格式
            timefilter(row){
                return timefilters(row.planTime)
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            dataChange(val){
                this.searchForm.startTime=val[0]
                this.searchForm.endTime=val[1]
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                
                console.log(getStaffDTO().businessCode)
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsBusinessCode/GoodsBusiness",
                    data: data,
                    // businessCode:businessCode
                }).then( (response)=> {
                    this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
        }
    }

</script>

<style lang="scss" scoped>
    .bankInfo{
        line-height: 30px;
        font-size: 16px;
        margin-top: 10px;
        color: #333;
    }
    .inputMoneyNumber /deep/ .el-input__inner{
        text-align: left;
    }
    .bankPrice{
        margin-top: 10px;
        span{
            line-height: 30px;
            margin-left: 5px;
        }
    }
</style>